// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ece-picker {
  display: flex;
  flex-direction: column;
  gap: 0;
}

/* ── Rider context strip ── */

.ece-rider-strip {
  padding: 0.75rem 0 0.875rem;
  border-bottom: 1px solid #f3f4f6;
  margin-bottom: 0.25rem;
}

.ece-rider-select {
  max-width: 280px;
  font-weight: 600;
  font-size: 0.9rem;
  color: #111827;
  border-color: #d1d5db;
  background-color: #f9fafb;
}
.ece-rider-select:focus {
  border-color: var(--sms-blue, #346498);
  box-shadow: 0 0 0 2px rgba(52, 100, 152, 0.12);
}

.ece-rider-hint {
  font-size: 0.75rem;
  color: #9ca3af;
  margin-top: 0.35rem;
  margin-bottom: 0;
}

/* ── Input blocks (sections / competitions) ── */

.ece-input-block {
  padding: 0.875rem 0;
  border-bottom: 1px solid #f3f4f6;
}

.ece-input-block__header {
  display: flex;
  align-items: baseline;
  gap: 0.6rem;
  margin-bottom: 0.5rem;
}

.ece-input-hint {
  font-size: 0.72rem;
  color: #9ca3af;
}

.ece-input-row {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.ece-col-number {
  flex: 0 0 140px;
}

.ece-col-search {
  flex: 1 1 220px;
  min-width: 0;
}

/* ── Add feedback toast ── */

.ece-add-feedback {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.8rem;
  color: #374151;
  padding: 0.5rem 0.75rem;
  margin-top: 0.5rem;
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 0.375rem;
  animation: ece-feedback 2.8s ease-out forwards;
}

.ece-add-feedback__icon {
  color: #16a34a;
}

@keyframes ece-feedback {
  0%   { opacity: 0; transform: translateY(-4px); }
  8%   { opacity: 1; transform: translateY(0); }
  75%  { opacity: 1; }
  100% { opacity: 0; transform: translateY(-4px); }
}

/* ── Declared list ── */

.ece-declared {
  padding-top: 0.875rem;
}

.ece-declared__header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.ece-declared__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.35rem;
  height: 1.35rem;
  padding: 0 0.3rem;
  border-radius: 9999px;
  background: var(--sms-blue, #346498);
  color: #fff;
  font-size: 0.65rem;
  font-weight: 700;
  line-height: 1;
}

.ece-declared__list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.ece-declared__item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.45rem 0.6rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.375rem;
  background: #fff;
}
.ece-declared__item:hover {
  border-color: #d1d5db;
  background: #fafafa;
}

.ece-badge {
  flex-shrink: 0;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  padding: 0.2em 0.45em;
  border-radius: 0.25rem;
}
.ece-badge--section {
  background: #eff6ff;
  color: #1d4ed8;
}
.ece-badge--class {
  background: #f0fdf4;
  color: #15803d;
}
.ece-badge--required {
  background: #fff7ed;
  color: #c2410c;
}

.ece-declared__name {
  flex: 1;
  font-size: 0.875rem;
  font-weight: 500;
  color: #111827;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ece-declared__rider {
  font-size: 0.75rem;
  color: #9ca3af;
  white-space: nowrap;
  flex-shrink: 0;
}

.ece-declared__remove {
  flex-shrink: 0;
  padding: 0.2rem 0.4rem;
  color: #9ca3af;
  border: none;
  background: transparent;
  line-height: 1;
}
.ece-declared__remove:hover {
  color: #dc2626;
  background: #fef2f2;
}

@media (max-width: 576px) {
  .ece-col-number { flex: 0 0 110px; }
  .ece-rider-select { max-width: 100%; }

  .ece-declared__item {
    flex-wrap: wrap;
    gap: 0.35rem;
  }
  .ece-declared__name { white-space: normal; }
  .ece-declared__rider { margin-left: auto; }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/edit-competition-entries/edit-competition-entries.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA,8BAA8B;;AAE9B;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,sCAAsC;EACtC,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iDAAiD;;AAEjD;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,6BAA6B;;AAE7B;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;EAC7C,OAAO,UAAU,EAAE;EACnB,OAAO,UAAU,EAAE,2BAA2B,EAAE;AAClD;;AAEA,wBAAwB;;AAExB;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB,eAAe,EAAE;EACnC,oBAAoB,eAAe,EAAE;;EAErC;IACE,eAAe;IACf,YAAY;EACd;EACA,sBAAsB,mBAAmB,EAAE;EAC3C,uBAAuB,iBAAiB,EAAE;AAC5C","sourcesContent":[".ece-picker {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n/* ── Rider context strip ── */\n\n.ece-rider-strip {\n  padding: 0.75rem 0 0.875rem;\n  border-bottom: 1px solid #f3f4f6;\n  margin-bottom: 0.25rem;\n}\n\n.ece-rider-select {\n  max-width: 280px;\n  font-weight: 600;\n  font-size: 0.9rem;\n  color: #111827;\n  border-color: #d1d5db;\n  background-color: #f9fafb;\n}\n.ece-rider-select:focus {\n  border-color: var(--sms-blue, #346498);\n  box-shadow: 0 0 0 2px rgba(52, 100, 152, 0.12);\n}\n\n.ece-rider-hint {\n  font-size: 0.75rem;\n  color: #9ca3af;\n  margin-top: 0.35rem;\n  margin-bottom: 0;\n}\n\n/* ── Input blocks (sections / competitions) ── */\n\n.ece-input-block {\n  padding: 0.875rem 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n\n.ece-input-block__header {\n  display: flex;\n  align-items: baseline;\n  gap: 0.6rem;\n  margin-bottom: 0.5rem;\n}\n\n.ece-input-hint {\n  font-size: 0.72rem;\n  color: #9ca3af;\n}\n\n.ece-input-row {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.ece-col-number {\n  flex: 0 0 140px;\n}\n\n.ece-col-search {\n  flex: 1 1 220px;\n  min-width: 0;\n}\n\n/* ── Add feedback toast ── */\n\n.ece-add-feedback {\n  display: flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.8rem;\n  color: #374151;\n  padding: 0.5rem 0.75rem;\n  margin-top: 0.5rem;\n  background: #f0fdf4;\n  border: 1px solid #bbf7d0;\n  border-radius: 0.375rem;\n  animation: ece-feedback 2.8s ease-out forwards;\n}\n\n.ece-add-feedback__icon {\n  color: #16a34a;\n}\n\n@keyframes ece-feedback {\n  0%   { opacity: 0; transform: translateY(-4px); }\n  8%   { opacity: 1; transform: translateY(0); }\n  75%  { opacity: 1; }\n  100% { opacity: 0; transform: translateY(-4px); }\n}\n\n/* ── Declared list ── */\n\n.ece-declared {\n  padding-top: 0.875rem;\n}\n\n.ece-declared__header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.ece-declared__count {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.35rem;\n  height: 1.35rem;\n  padding: 0 0.3rem;\n  border-radius: 9999px;\n  background: var(--sms-blue, #346498);\n  color: #fff;\n  font-size: 0.65rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.ece-declared__list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.ece-declared__item {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.45rem 0.6rem;\n  border: 1px solid #e5e7eb;\n  border-radius: 0.375rem;\n  background: #fff;\n}\n.ece-declared__item:hover {\n  border-color: #d1d5db;\n  background: #fafafa;\n}\n\n.ece-badge {\n  flex-shrink: 0;\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  padding: 0.2em 0.45em;\n  border-radius: 0.25rem;\n}\n.ece-badge--section {\n  background: #eff6ff;\n  color: #1d4ed8;\n}\n.ece-badge--class {\n  background: #f0fdf4;\n  color: #15803d;\n}\n.ece-badge--required {\n  background: #fff7ed;\n  color: #c2410c;\n}\n\n.ece-declared__name {\n  flex: 1;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #111827;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.ece-declared__rider {\n  font-size: 0.75rem;\n  color: #9ca3af;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.ece-declared__remove {\n  flex-shrink: 0;\n  padding: 0.2rem 0.4rem;\n  color: #9ca3af;\n  border: none;\n  background: transparent;\n  line-height: 1;\n}\n.ece-declared__remove:hover {\n  color: #dc2626;\n  background: #fef2f2;\n}\n\n@media (max-width: 576px) {\n  .ece-col-number { flex: 0 0 110px; }\n  .ece-rider-select { max-width: 100%; }\n\n  .ece-declared__item {\n    flex-wrap: wrap;\n    gap: 0.35rem;\n  }\n  .ece-declared__name { white-space: normal; }\n  .ece-declared__rider { margin-left: auto; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
